import _ from 'underscore'

export default {

	namespaced: true,

	modules: {},

	state: {

		data: []

	},

	getters: {

		list: function(state) {

			return _.sortBy(state.data, 'artist_name')

		},

		associated: function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.artist_id] = item

			})

			return associated

		}

	},

	mutations: {

		add: function(state, items) {

			_.each(items, function(item) {

				if (!_.contains(_.pluck(state.data, 'artist_id'), item.artist_id)) {

					state.data.push(item)

				}

			})

		}

	},

	actions: {}

}
